import { useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { Card, Divider, List, Tag, Tooltip } from 'antd'
import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'

import SchoolNote from './SchoolNote'
import { Contexts } from '../../../../../utils/constants'
import { getUser } from '../../../../../reducers/UserReducer'
import { GlobalContext } from '../../../../../Providers/GlobalProvider'
import { ColorsPalette } from '../../../../../config/colors'
import { Ownership } from '../../../../../utils/entities/internship'

const INFO_BUTTON_COLOR = '#3787BF'
const CARD_GLOBAL_STYLE = { backgroundColor: 'rgba(0, 0, 0, 0)', border: '0px' }
const CARD_HEAD_STYLE = { color: 'white', fontSize: '12px' }
const TITLE_STYLE = { overflow: 'unset', whiteSpace: 'pre-wrap' }
const CARD_BODY_STYLE = { padding: '0px 12px 0px 12px', textAlign: 'center' }
const LIST_STYLE = { color: 'white', fontSize: '10px' }
const TAG_STYLE = { color: 'black', minWidth: '50px' }
const DEFAULT_TITLE = 'Available codes:'
const SECTOR_TITLE = 'internship_card.sector_available_codes'
const LIST_ITEM_STYLE = {
  borderBottom: '0px', display: 'flex', flexDirection: 'row', alignItem: 'center', alignContent: 'space-between'
}

const mapStateToProps = state => ({
  t: getTranslate(state.locale),
  user: getUser(state.getUser)
})

const PresetsTooltip = props => {
  const { isReadOnly } = useContext(GlobalContext)

  const makePresetsCodesTooltipContent = (presets, sectorNote) => {
    return (
      <>
        {props?.internship?.ownership && (
          <div style={{ display: 'flex', flexFlow: 'column', width: '100%', marginTop: '10px', marginBottom: 0 }}>
            {getOwnershipLabel()}
            <Divider style={{ marginTop: '3px', marginBottom: '3px' }} />
          </div>
        )}
        {props.user.context === Contexts.SCHOOL && <SchoolNote note={sectorNote} />}
        <Card
          size='small'
          style={CARD_GLOBAL_STYLE}
          headStyle={CARD_HEAD_STYLE}
          bodyStyle={CARD_BODY_STYLE}
          title={getTitle()}
        >
          <List
            style={LIST_STYLE}
            size='small'
            dataSource={presets}
            renderItem={item => {
              return (
                <List.Item
                  style={LIST_ITEM_STYLE}
                >
                  <Tag
                    color={item.color}
                    style={{ ...TAG_STYLE, color: item.textColor ?? ColorsPalette.BLACK }}
                  >
                    {item.periodCode}
                  </Tag>
                  ({item.startTime.slice(0, item.startTime.length - 3)} - {item.endTime.slice(0, item.startTime.length - 3)})
                </List.Item>
              )
            }}
          />
        </Card>
      </>
    )
  }

  const getOwnershipLabel = () => {
    let ownershipLabel = ''
    if (props.internship.ownership === Ownership.INSTITUTION) {
      ownershipLabel = props.t('internship_card.ownership_institution')
    } else if (props.internship.ownership === Ownership.SCHOOL) {
      ownershipLabel = props.t('internship_card.ownership_school')
    } else {
      ownershipLabel = props.t('internship_card.ownership_other')
    }

    return (
      <span style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'center' }}>
        {props.t('common.internship')} : {ownershipLabel}
      </span>
    )
  }

  const getTitle = () => {
    return (
      <span style={TITLE_STYLE}>
        {props.t(props.title ?? (props.internship ? SECTOR_TITLE : DEFAULT_TITLE))}
      </span>
    )
  }

  return (
    <>
      {!isReadOnly &&
        <Tooltip
          placement={props.placement ?? 'right'}
          title={makePresetsCodesTooltipContent(props.presets, props.sectorNote)}
          className='tutoriel-bouton-aide'
        >
          <FontAwesomeIcon
            icon={props.icon ?? faInfoCircle} color={props.iconColor ?? INFO_BUTTON_COLOR}
          />
        </Tooltip>}
    </>
  )
}

export default connect(mapStateToProps)(PresetsTooltip)
